const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getSepaType } = require('utilities/transfersHelper');

const requestDetailsSuccess = (response, accountId, transferId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_DETAILS_SUCCESS,
    payload: {
        transferId: transferId,
        details: response,
        accountId: accountId
    }
})

const requestDetailsFailure = (error, accountId, transferId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_DETAILS_FAILURE,
    payload: {
        transferId: transferId,
        error: error,
        accountId: accountId
    }
});

const requestDetailsRequest = (accountId, transferId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_DETAILS_REQUEST,
    payload: {
        transferId: transferId,
        accountId: accountId
    }
});

const requestDetails = immTransfer => dispatch => {
    let sepaType;
    if (immTransfer.get('type') === 'D7'){
        sepaType = 'D7';
    } else {
        sepaType = getSepaType(immTransfer.get('country'), immTransfer.getIn(['amount', 'currency']));
    }

    const detailsRequestData = {
        header: {
            version: '2'
        },
        query: {
            refProducto: immTransfer.getIn(['reference', 'product']),
            refNumeroDeOrden: immTransfer.getIn(['reference', 'number']),
            tipoTransferencia: immTransfer.get('type'),
            tipoSepa: sepaType,
            numTrnsf: immTransfer.get('numTrnsf')
        }
    };

    const accountId = immTransfer.get('accountId');
    const transferId = immTransfer.get('id');

    dispatch(requestDetailsRequest(accountId, transferId));
    return APIGet(dispatch, apiURLBuilder.getURL('receivedTransfersDetails'), detailsRequestData)
        .then(function(response) {
            dispatch(requestDetailsSuccess(response, accountId, transferId));
        }, function(response) {
            dispatch(requestDetailsFailure(response, accountId, transferId))
        }
    );
};

const getDetails = requestDetails;

module.exports = {
    getDetails
}
